import config from "../../app.json";
import axios from "axios";

import AlertComponent from "../../Components/AlertComponent";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

import CsWhiteLogo from "../../Assets/Svgs/cs-white-logo.svg";
import AwsLogo from "../../Assets/Svgs/aws-logo.svg";
import FieldText from "../../Components/Fields/FieldText";

function RecoverPasswordConfirmation() {
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);

  let navigate = useNavigate();
  const location = useLocation();
  const { email, code } = location.state;

  if (!email) {
    navigate("/recoverpassword", { replace: false });
  }

  if (!code) {
    navigate("/recoverPasswordCode", {
      state: { email: email },
      replace: false,
    });
  }

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (!password) {
      setPasswordError("Password is required");
    } else if (!confirmPassword) {
      setConfirmPasswordError("Confirm Password is required");
    } else if (password !== confirmPassword) {
      setPasswordError("Password and Confirm Password do not match");
      setConfirmPasswordError("Password and Confirm Password do not match");
    } else {
      setPasswordError(null);
      setConfirmPasswordError(null);
      axios
        .post(config.API + "/api/user/resetPassword", {
          email: email,
          code: code,
          password: password,
        })
        .then((res) => {
          const data = res.data;
          if (res.status === 200) {
            AlertComponent("Success", "Your password was reseted");
            return navigate("/login", { replace: false });
          } else {
            return AlertComponent("Error", data.error || data.message, {
              icon: `error`,
            });
          }
        })
        .catch(function (error) {
          if (error?.response?.data?.error === "Invalid code") {
            AlertComponent(
              "Error",
              error?.response?.data?.error || error?.message,
              { icon: `error` }
            );

            return navigate("/recoverPasswordCode", {
              state: { email: email },
              replace: false,
            });
          }
          return AlertComponent(
            "Error",
            error?.response?.data?.error || error?.message,
            { icon: `error` }
          );
        });
    }
  };

  return (
    <div className="prelogin-container">
      <div className="containerLoginForm">
        <Row className="header-login">
          <Col className="col-md-6">
            <img className="cs-logo-login" src={CsWhiteLogo} />
          </Col>
          <Col className="col-md-6">
            <img className="aws-logo-login" src={AwsLogo} />
          </Col>
        </Row>
        <Row className="login-body">
          <Col className="col-md-7 cs-3d-phone">
            <iframe
              src="https://my.spline.design/untitled-c751e6b7fc77254e43fcafa257e796e6/"
              frameBorder="0"
              width="100%"
              height="100%"
            ></iframe>
          </Col>
          <Col className="col-md-5 cs-login-form ">
            <Row>
              <Col className="col-md-12">
                <h2>Recover Password</h2>
              </Col>
            </Row>
            <Row className="verification-code verificationForm">
              <form onSubmit={handleResetPassword}>
                <FieldText
                  label="New Password"
                  type="password"
                  placeholder="Enter your new password"
                  onChange={(x) => {
                    setPassword(x.target.value);
                  }}
                  value={password}
                  className="password-field"
                  error={passwordError}
                  required={true}
                  inputClassName={`inputOption passwordInput`}
                />

                <FieldText
                  label="Confirm Password"
                  type="password"
                  placeholder="Confirm your new password"
                  onChange={(x) => setConfirmPassword(x.target.value)}
                  value={confirmPassword}
                  className="password-field"
                  error={confirmPasswordError}
                  required={true}
                  inputClassName={`inputOption passwordInput`}
                />

                <div className="form-group mt-3 loginAlignCenter">
                  <button type="submit" className="btn submitCode col-md-12">
                    Reset Password
                  </button>
                </div>
              </form>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default RecoverPasswordConfirmation;
